import React, { Component } from 'react';
import { API_ROOT } from '../../../baseUrls';
import { withStyles } from "@mui/styles";
import { connect } from 'react-redux';
import { updateMindfilePrivacyLevel } from '../../../state/actions/updateDataActions';
import {
  Box,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Button,
} from '@mui/material';
import Alert from '@mui/material/Alert';

const styles = () => ({
  fieldWrapper: {
    marginBottom: 16,
  },
  buttonWrapper: {
    marginTop: 24,
  }
})

class MindfileVisibility extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mindfileVisibilityMode: 'display',
      showPrivacySuccessMessage: false,
    }
  }

  updatePrivacy() {
    const formData = new FormData()
    formData.append("mindfile[privacy_level]", this.props.mindfile.privacy_level)
    formData.append("mindfile[group]", this.props.mindfile.group)
    // formData.append("authenticity_token", this.props.user.authenticity_token)

    fetch(`${ API_ROOT }/mindfiles/${ this.props.mindfile.id }/update`, {
      method: 'POST',
      credentials: 'include',
      body: formData,
      headers: {'X-CSRF-Token': this.props.user.authenticity_token},
    })
    .then(resp => (resp.json()))
    .then(data => {
      if (data.status === 'ok') {
        this.setState({
          mindfileVisibilityMode: 'display',
          showPrivacySuccessMessage: true,
        })
      }
    })
    .catch(error => console.error(error))
  }

  getVisibilityLabel(value) {
    switch (value) {
      case 'private':
        return 'Only me'
      case 'friends':
        return 'My friends'
      case 'public':
        return 'Everyone'
      default:
        return value
    }
  }

  renderMindfileVisibilityDisplay() {
    return (
      <Box>
        { this.state.showPrivacySuccessMessage ?<Box style={{marginBottom: "1rem"}}> <Alert onClose={ () => this.setState({ showPrivacySuccessMessage: false }) }>Mindfile visibility was updated.</Alert></Box> : '' }
        <Box sx={{ display: { xs: 'block', md: 'none' } }} pb={2}><Typography>Mindfile visibility</Typography></Box>
        <div style={{display:"flex", gap:"0.5rem"}}>
          <Box sx={{ display: { xs: 'none', md: 'block' } }}><Typography>Mindfile visibility</Typography></Box>
          <Box display="flex" flexGrow={1} justifyContent="center"><Typography>{ this.getVisibilityLabel(this.props.mindfile.privacy_level) }</Typography></Box>
          <Button variant="contained" color="primary" onClick={ () => this.setState({ mindfileVisibilityMode: 'form' }) }>Update</Button>
        </div>
      </Box>
    )
  }

  renderMindfileVisibilityForm(classes) {
    return (
      <Box>
        <Typography className={classes.cardTitle} variant="subtitle1" gutterBottom>
          Mindfile visibility
        </Typography>
        <Box className={ classes.fieldWrapper }>
          <FormControl component="fieldset">
            <RadioGroup
              name="mindfile-visibility"
              value={ (this.props.mindfile.privacy_level) ? this.props.mindfile.privacy_level : null }
              onChange={ (evt) => this.props.updateMindfilePrivacyLevel(evt.target.value) }
            >
              <FormControlLabel value="public" control={<Radio />} label="Everyone" />
              <FormControlLabel value="friends" control={<Radio />} label="My friends" />
              <FormControlLabel value="private" control={<Radio />} label="Only me" />
            </RadioGroup>
          </FormControl>
        </Box>
        <Box className={ classes.buttonWrapper }>
          <Button variant="contained" color="primary" onClick={ this.updatePrivacy.bind(this) }>Update</Button>
          <Button style={{ marginLeft: 8 }} variant="contained" color="primary" onClick={ () => this.setState({ mindfileVisibilityMode: 'display' }) }>Cancel</Button>
        </Box>
      </Box>
    )
  }

  render() {
    const { classes } = this.props
    return (this.state.mindfileVisibilityMode === 'display') ? this.renderMindfileVisibilityDisplay(classes) : this.renderMindfileVisibilityForm(classes)
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.auth,
    mindfile: state.mindfile,
  }
}

const mapDispatchToProps = {
  updateMindfilePrivacyLevel,
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MindfileVisibility))
